<template>
    <v-dialog v-model="$store.getters.getModalBaixaContaPagar" persistent :overlay="$store.getters.getOverlay"
        max-width="720px">
        <v-card outline>
            <v-card-title>
                Baixar
            </v-card-title>
            <v-card-text>
                <h3 align="center">Tem certeza que deseja baixar conta?</h3>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" outlined @click="setModalBaixaContaPagar(false)">Voltar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" outlined @click="baixarContaPagar(getContaPagar)">Sim</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'
    export default {
        computed: {
            ...mapGetters([
                'getModalBaixaContaPagar',
                'getContaPagar'
            ])
        },
        methods: {
            ...mapActions([
                'setModalBaixaContaPagar',
                'baixarContaPagar'
            ])
        }
    }
</script>